import apiService from '../utils/apiService';

import {
  ADD_REQUEST_FOR_SIGNET_APPROVAL,
  ADD_REQUEST_FOR_SIGNET_APPROVAL_START,
  ADD_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
  UPDATE_REQUEST_FOR_SIGNET_APPROVAL,
  UPDATE_REQUEST_FOR_SIGNET_APPROVAL_START,
  UPDATE_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL,
  GET_REQUEST_FOR_SIGNET_APPROVAL_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_ERROR,
  DELETE_REQUEST_FOR_SIGNET_APPROVAL,
  DELETE_REQUEST_FOR_SIGNET_APPROVAL_START,
  DELETE_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
  CLEAR_ERROR_REQUEST_FOR_SIGNET,
  GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_PAGEABLE,
  CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS,
  CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_START,
  CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_ERROR,
  SET_PROCCESOR_FOR_REQUEST_APPROVAL,
  SET_PROCCESOR_FOR_REQUEST_APPROVAL_START,
  SET_PROCCESOR_FOR_REQUEST_APPROVAL_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_ERROR,
  DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_START,
  DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_ERROR,
  DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION_START,
  DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_ERROR,
  CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER,
  CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_START,
  CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_START,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_ERROR,
  GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_START,
} from './types';

import {
  requestForSignetApprovalAddPath,
  requestForSignetApprovalUpdatePath,
  requestForSignetApprovalFindAllPath,
  requestForSignetApprovalFindByIdPath,
  requestForSignetApprovalDeletePath,
  requestForSignetApprovalFindAllPageablePath,
  changeRequestForSignetApprovalStatusPath,
  requestForSignetApprovalAddProcessorRequestPath,
  requestForSignetApprovalAttachmentFindAllPath,
  requestForSignetApprovalAttachmentDownloadPath,
  requestForSignetApprovalProposalSolutionDownloadPath,
  filterPageablePath,
  createRequestForSignetApprovalReferenceNumberPath,
  requestForSignetApprovalFindAllByProcessorPath,
  requestForSignetApprovalFindAllByInspectorPath,
  requestForSignetApprovalFindAllByClientPath,
  requestForSignetApprovalRequestDownloadPath,
  requestForSignetApprovalClientUpdatePath,
} from '../constants/apiEndpoints';
import { createNotification } from '../utils';
import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';

const clearError = () => {
  return {
    type: CLEAR_ERROR_REQUEST_FOR_SIGNET,
  };
};

const addRequestForSignetApprovalStart = () => {
  return {
    type: ADD_REQUEST_FOR_SIGNET_APPROVAL_START,
  };
};
const addRequestForSignetApprovalSuccessfully = (data) => {
  return {
    type: ADD_REQUEST_FOR_SIGNET_APPROVAL,
    payload: data,
  };
};
const addRequestForSignetApprovalUnsuccessfully = (err) => {
  return {
    type: ADD_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
    payload: err,
  };
};

const updateRequestForSignetApprovalStart = () => {
  return {
    type: UPDATE_REQUEST_FOR_SIGNET_APPROVAL_START,
  };
};
const updateRequestForSignetApprovalSuccessfully = (data) => {
  return {
    type: UPDATE_REQUEST_FOR_SIGNET_APPROVAL,
    payload: data,
  };
};
const updateRequestForSignetApprovalUnsuccessfully = (err) => {
  return {
    type: UPDATE_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
    payload: err,
  };
};

const getRequestForSignetApprovalStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_START,
  };
};
const getRequestForSignetApprovalSuccessfully = (data) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL,
    payload: data,
  };
};
const getRequestForSignetApprovalUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
    payload: err,
  };
};

const getRequestForSignetApprovalListStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_START,
  };
};
const getRequestForSignetListApprovalSuccessfully = (data) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_LIST,
    payload: data,
  };
};

const getRequestForSignetApprovalPageableListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};
const getRequestForSignetApprovalListUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_LIST_ERROR,
    payload: err,
  };
};

const deleteRequestForSignetApprovalStart = () => {
  return {
    type: DELETE_REQUEST_FOR_SIGNET_APPROVAL_START,
  };
};
const deleteRequestForSignetApprovalSuccessfully = (id) => {
  return {
    type: DELETE_REQUEST_FOR_SIGNET_APPROVAL,
    payload: id,
  };
};
const deleteRequestForSignetApprovalUnsuccessfully = (err) => {
  return {
    type: DELETE_REQUEST_FOR_SIGNET_APPROVAL_ERROR,
    payload: err,
  };
};

const downloadRequestForSignetApprovalAttachmentStart = () => {
  return {
    type: DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_START,
  };
};
const downloadRequestForSignetApprovalAttachmentSuccessfully = (
  data,
  documentName
) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', documentName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
};
const downloadRequestForSignetApprovalAttachmentUnsuccessfully = (err) => {
  return {
    type: DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_ERROR,
    payload: err,
  };
};

const downloadRequestForSignetApprovalProposalSolutionStart = () => {
  return {
    type: DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION_START,
  };
};
const downloadRequestForSignetApprovalProposalSolutionSuccessfully = (
  data,
  documentName,
  messages
) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', documentName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
  createNotification(
    notificationTypeSuccess,
    messages.requestTitle,
    messages.successDownload
  );
};
const downloadRequestForSignetApprovalProposalSolutionUnsuccessfully = (
  err
) => {
  return {
    type: DOWNLOAD_REQUEST_FOR_SIGNET_APPROVAL_PROPOSAL_SOLUTION_ERROR,
    payload: err,
  };
};

const changeRequestForSignetApprovalStatusStart = () => {
  return {
    type: CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_START,
  };
};
const changeRequestForSignetApprovalStatusSuccessfully = (data) => {
  return {
    type: CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS,
    payload: data,
  };
};
const changeRequestForSignetApprovalStatusUnsuccessfully = (err) => {
  return {
    type: CHANGE_REQUEST_FOR_SIGNET_APPROVAL_STATUS_ERROR,
    payload: err,
  };
};

const addProcessorRequestForSignetApprovalStart = () => {
  return {
    type: SET_PROCCESOR_FOR_REQUEST_APPROVAL_START,
  };
};
const addProcessorRequestForSignetApprovalSuccessfully = (data) => {
  return {
    type: SET_PROCCESOR_FOR_REQUEST_APPROVAL,
    payload: data,
  };
};
const addProcessorRequestForSignetApprovalUnsuccessfully = (err) => {
  return {
    type: SET_PROCCESOR_FOR_REQUEST_APPROVAL_ERROR,
    payload: err,
  };
};
const getRequestForSignetApprovalAttachmentsUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_ERROR,
    payload: err,
  };
};

const getRequestForSignetApprovalAttachmentsStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST_START,
  };
};
const getRequestForSignetApprovalAttachmentsSuccessfully = (data) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_ATTACHMENT_LIST,
    payload: data,
  };
};

const getRequestForSignetFilterListStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_START,
  };
};
const getRequestForSignetFilterListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getRequestForSignetFilterListUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_FILTER_LIST_ERROR,
    payload: err,
  };
};

const createRequestForSignetApprovalReferenceNumberStart = () => {
  return {
    type: CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_START,
  };
};
const createRequestForSignetApprovalReferenceNumberSuccessfully = (data) => {
  return {
    type: CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER,
    payload: data,
  };
};
const createRequestForSignetApprovalReferenceNumberUnsuccessfully = (err) => {
  return {
    type: CREATE_REQUEST_FOR_SIGNET_APPROVAL_REFERENCE_NUMBER_ERROR,
    payload: err,
  };
};

const getRequestForSignetApprovalByProcessorListStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_START,
  };
};

const getRequestForSignetApprovalByInspectorListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getRequestForSignetApprovalByInspectorListUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_ERROR,
    payload: err,
  };
};

const getRequestForSignetApprovalByInspectorListStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_INSPECTOR_LIST_START,
  };
};

const getRequestForSignetApprovalByProcessorListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getRequestForSignetApprovalByProcessorListUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_PROCESSOR_LIST_ERROR,
    payload: err,
  };
};

const getRequestForSignetApprovalByClientListStart = () => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_START,
  };
};

const getRequestForSignetApprovalByClientListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getRequestForSignetApprovalByClientListUnsuccessfully = (err) => {
  return {
    type: GET_REQUEST_FOR_SIGNET_APPROVAL_BY_CLIENT_LIST_ERROR,
    payload: err,
  };
};

export const createRequestForSignetApproval = (
  requestForSignet,
  callback,
  createNotificationCallback,
  message
) => {
  return (dispatch) => {
    dispatch(addRequestForSignetApprovalStart());
    return apiService
      .post(requestForSignetApprovalAddPath(), requestForSignet)
      .then((response) => {
        dispatch(addRequestForSignetApprovalSuccessfully(response.data));
        callback();
        createNotificationCallback();
      })
      .catch((err) => {
        dispatch(
          addRequestForSignetApprovalUnsuccessfully(err?.response?.data)
        );
        createNotification(
          notificationTypeError,
          message.requestTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const updateRequestForSignetApproval = (
  requestForSignet,
  callback,
  messages
) => {
  return (dispatch) => {
    dispatch(updateRequestForSignetApprovalStart());
    return apiService
      .post(requestForSignetApprovalUpdatePath(), requestForSignet)
      .then((response) => {
        dispatch(updateRequestForSignetApprovalSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          messages.requestTitle,
          messages.successUpdateRequest
        );
      })
      .catch((err) => {
        dispatch(
          updateRequestForSignetApprovalUnsuccessfully(err?.response?.data)
        );
        createNotification(
          notificationTypeError,
          messages.requestTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const findAllRequestForSignetsApprovals = () => {
  return (dispatch) => {
    dispatch(getRequestForSignetApprovalListStart());
    return apiService
      .get(requestForSignetApprovalFindAllPath())
      .then((response) => {
        dispatch(getRequestForSignetListApprovalSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetApprovalListUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const findAllRequestForSignetsApprovalsPageble = (
  pageNumber,
  pageSize
) => {
  return (dispatch) => {
    dispatch(getRequestForSignetApprovalListStart());
    return apiService
      .get(requestForSignetApprovalFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getRequestForSignetApprovalPageableListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetApprovalListUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const findAllRequestForSignetsApprovalsByProcessor = (
  pageNumber,
  pageSize
) => {
  return (dispatch) => {
    dispatch(getRequestForSignetApprovalByProcessorListStart());
    return apiService
      .get(requestForSignetApprovalFindAllByProcessorPath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getRequestForSignetApprovalByProcessorListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetApprovalByProcessorListUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const findAllRequestForSignetsApprovalsByInspector = (
  pageNumber,
  pageSize
) => {
  return (dispatch) => {
    dispatch(getRequestForSignetApprovalByInspectorListStart());
    return apiService
      .get(requestForSignetApprovalFindAllByInspectorPath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getRequestForSignetApprovalByInspectorListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetApprovalByInspectorListUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const findAllRequestForSignetsApprovalsByClient = (
  userId,
  pageNumber,
  pageSize
) => {
  return (dispatch) => {
    dispatch(getRequestForSignetApprovalByClientListStart());
    return apiService
      .get(
        requestForSignetApprovalFindAllByClientPath(
          userId,
          pageNumber,
          pageSize
        )
      )
      .then((response) => {
        dispatch(
          getRequestForSignetApprovalByClientListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetApprovalByClientListUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const findRequestForSignetApprovalById = (id) => {
  return (dispatch) => {
    dispatch(getRequestForSignetApprovalStart());
    return apiService
      .get(requestForSignetApprovalFindByIdPath(id))
      .then((response) => {
        dispatch(getRequestForSignetApprovalSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetApprovalUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const deleteRequestForSignetApproval = (id) => {
  return (dispatch) => {
    dispatch(deleteRequestForSignetApprovalStart());
    return apiService
      .delete(requestForSignetApprovalDeletePath(id))
      .then(() => {
        dispatch(deleteRequestForSignetApprovalSuccessfully(id));
      })
      .catch((err) => {
        dispatch(
          deleteRequestForSignetApprovalUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const downloadAttachment = (uuidDocName, documentName) => async (
  dispatch
) => {
  dispatch(downloadRequestForSignetApprovalAttachmentStart());
  return apiService
    .getFromFile(requestForSignetApprovalAttachmentDownloadPath(uuidDocName))
    .then((response) => {
      dispatch(
        downloadRequestForSignetApprovalAttachmentSuccessfully(
          response.data,
          documentName
        )
      );
    })
    .catch((err) => {
      dispatch(
        downloadRequestForSignetApprovalAttachmentUnsuccessfully(
          err?.response?.data
        )
      );
    });
};

export const downloadProposalSolution = (
  requestForSignetApproval,
  message
) => async (dispatch) => {
  dispatch(downloadRequestForSignetApprovalProposalSolutionStart());
  return apiService
    .getFromFile(
      requestForSignetApprovalProposalSolutionDownloadPath(
        requestForSignetApproval.id
      )
    )
    .then((response) => {
      dispatch(
        downloadRequestForSignetApprovalProposalSolutionSuccessfully(
          response.data,
          'Предлог решења.docx',
          message
        )
      );
    })
    .catch((err) => {
      dispatch(
        downloadRequestForSignetApprovalProposalSolutionUnsuccessfully(
          err?.response?.data
        )
      );
      if (err?.response?.status === 500) {
        createNotification(
          notificationTypeError,
          message.decisionTitleError,
          message.unsuccessDownload
        );
      }
    });
};

export const downloadRequest = (requestForSignetApprovalId, message) => async (
  dispatch
) => {
  dispatch(downloadRequestForSignetApprovalProposalSolutionStart());
  return apiService
    .getFromFile(
      requestForSignetApprovalRequestDownloadPath(requestForSignetApprovalId)
    )
    .then((response) => {
      dispatch(
        downloadRequestForSignetApprovalProposalSolutionSuccessfully(
          response.data,
          'Захтев за давање сагласности на садржину и изглед печата.docx',
          message
        )
      );
    })
    .catch((err) => {
      dispatch(
        downloadRequestForSignetApprovalProposalSolutionUnsuccessfully(
          err?.response?.data
        )
      );
      if (err?.response?.status === 500) {
        createNotification(
          notificationTypeError,
          message.decisionTitleError,
          message.unsuccessDownload
        );
      }
    });
};

export const deleteErrorRequestForSignetApproval = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const changeRequestForSignetApprovalStatus = (
  id,
  status,
  callback,
  message
) => {
  return (dispatch) => {
    dispatch(changeRequestForSignetApprovalStatusStart());
    return apiService
      .patch(changeRequestForSignetApprovalStatusPath(id, status))
      .then((response) => {
        dispatch(
          changeRequestForSignetApprovalStatusSuccessfully(response.data)
        );
        callback();
        status === 'ACCEPTED' &&
          createNotification(
            notificationTypeSuccess,
            message.requestTitle,
            message.successAcceptRequest
          );
        status === 'COMPLEMENTED' &&
          createNotification(
            notificationTypeSuccess,
            message.requestTitle,
            message.successUpdate
          );
        status === 'IN_PROCESSING' &&
          createNotification(
            notificationTypeSuccess,
            message.requestTitle,
            message.successInProcessingRequest
          );
      })
      .catch((err) => {
        dispatch(
          changeRequestForSignetApprovalStatusUnsuccessfully(
            err?.response?.data
          )
        );
        createNotification(
          notificationTypeError,
          message.requestTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const addProcessorRequestForSignetApproval = (id, callback, message) => {
  return (dispatch) => {
    dispatch(addProcessorRequestForSignetApprovalStart());
    return apiService
      .post(requestForSignetApprovalAddProcessorRequestPath(id))
      .then((response) => {
        dispatch(
          addProcessorRequestForSignetApprovalSuccessfully(response.data)
        );
        callback();
        createNotification(
          notificationTypeSuccess,
          message.requestTitle,
          message.successAddProcessor
        );
      })
      .catch((err) => {
        dispatch(
          addProcessorRequestForSignetApprovalUnsuccessfully(
            err?.response?.data
          )
        );
        createNotification(
          notificationTypeError,
          message.requestTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const findAllRequestForSignetApprovalAttachments = (
  requestForSignetApprovalId
) => {
  return (dispatch) => {
    dispatch(getRequestForSignetApprovalAttachmentsStart());
    return apiService
      .get(
        requestForSignetApprovalAttachmentFindAllPath(
          requestForSignetApprovalId
        )
      )
      .then((response) => {
        dispatch(
          getRequestForSignetApprovalAttachmentsSuccessfully(response.data)
        );
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetApprovalAttachmentsUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const findAllRequestForSignetFilterPageable = (
  pageNumber,
  pageSize,
  data,
  succesCallback
) => {
  return (dispatch) => {
    dispatch(getRequestForSignetFilterListStart());
    return apiService
      .post(filterPageablePath(pageNumber, pageSize), data)
      .then((response) => {
        dispatch(
          getRequestForSignetFilterListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
        succesCallback();
      })
      .catch((err) => {
        dispatch(
          getRequestForSignetFilterListUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const createRequestForSignetApprovalReferenceNumber = (
  id,
  referenceNumber,
  callback,
  createNotificationCallback,
  message
) => {
  return (dispatch) => {
    dispatch(createRequestForSignetApprovalReferenceNumberStart());
    return apiService
      .post(
        createRequestForSignetApprovalReferenceNumberPath(id),
        referenceNumber
      )
      .then((response) => {
        dispatch(
          createRequestForSignetApprovalReferenceNumberSuccessfully(
            response.data
          )
        );
        callback();
        createNotificationCallback();
      })
      .catch((err) => {
        dispatch(
          createRequestForSignetApprovalReferenceNumberUnsuccessfully(
            err?.response?.data
          )
        );
        createNotification(
          notificationTypeError,
          message.requestTitle,
          (!err?.response?.data?.message.includes(
            'DataIntegrityViolationException'
          ) &&
            err?.response?.data?.message) ||
            message.unsuccessMessage
        );
      });
  };
};

export const updateRequestClient = (
  requestForUpdate,
  callback,
  messages,
  callback2
) => {
  return (dispatch) => {
    dispatch(updateRequestForSignetApprovalStart());
    return apiService
      .post(requestForSignetApprovalClientUpdatePath(), requestForUpdate)
      .then((response) => {
        dispatch(updateRequestForSignetApprovalSuccessfully(response.data));
        callback();
        callback2();
        createNotification(
          notificationTypeSuccess,
          messages.requestTitle,
          messages.successUpdateRequest
        );
      })
      .catch((err) => {
        dispatch(
          updateRequestForSignetApprovalUnsuccessfully(err?.response?.data)
        );
        createNotification(
          notificationTypeError,
          messages.requestTitle,
          err?.response?.data?.message
        );
      });
  };
};
